import React from 'react'
import PropTypes from 'prop-types'
import { LeftArrowIconThick, RightArrowIconThick, TrashIcon } from 'images'
import { useTranslation } from 'react-i18next'

const InfoCardHeader = (props) => {
  const { images, selectedImageId, onRemoveCard, onSelectPreviousCard, onSelectNextCard, readonly, coCreateSlot } = props
  const imageIndex = images.findIndex((image) => image.id === selectedImageId) + 1
  const { t } = useTranslation()
  if (imageIndex <= 0) return null

  return (
    <div className="info-card-header">
      <div className="info-card-header-left"> 
        <div className="cards-switcher">
          <div className="cards-switcher-buttons">
            <button disabled={imageIndex === 1} type="button" onClick={onSelectPreviousCard}>
              <LeftArrowIconThick width={18} height={18} />
            </button>

            <button disabled={imageIndex === images.length} type="button" onClick={onSelectNextCard}>
              <RightArrowIconThick width={18} height={18} />
            </button>
          </div>

          <p className="cards-switcher-index">{`${t('Recommendations.campaign.setup.carouselAd.card')} ${imageIndex}/${images.length}`}</p>
        </div>
        {coCreateSlot}
      </div>

      {images.length > 3 && !readonly && <span className="remove-card-icon">
        <TrashIcon onClick={onRemoveCard} width={14} height={14} />
      </span>}
    </div>
  )
}

export default InfoCardHeader

InfoCardHeader.propTypes = {
  images: PropTypes.array.isRequired,
  selectedImageId: PropTypes.string,
  onRemoveCard: PropTypes.func,
  onSelectPreviousCard: PropTypes.func,
  onSelectNextCard: PropTypes.func,
  readonly: PropTypes.bool,
  coCreateSlot: PropTypes.node,
}